import CheckBox from "../CheckBox"

const FulfillmentMethods = ({methods}) => {
    if (!methods || typeof methods !== "object") return null
    const {delivery, pickup} = methods
    return (
        <div className="display-flex justify-content-center gap-2">
            <span>{pickup ? "✅" : "❌"} Pickup</span>
            <span>|</span>
            <span>{delivery ? "✅" : "❌"} Delivery</span>
        </div>
    )
} 

export default FulfillmentMethods